import { render, staticRenderFns } from "./ThankLayout.vue?vue&type=template&id=145bc09d&scoped=true&"
import script from "./ThankLayout.vue?vue&type=script&lang=js&"
export * from "./ThankLayout.vue?vue&type=script&lang=js&"
import style0 from "./ThankLayout.vue?vue&type=style&index=0&id=145bc09d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145bc09d",
  null
  
)

export default component.exports